import Indicator from '../Indicator';
import CircleMarker from '../markers/CircleMarker';

/** PSAR indicator */
export default class PSARIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} componentSeries - Indicator component series
	 */
	_getDefaultParams() {
		return {
			id: 'psar',
			name: 'PSAR',
			description:
				'Parabolic SAR signals the potential reversal of a trend.',
			inputs: [
				{ name: 'initialPosition', value: 0 },
				{ name: 'accelerationIncrease', value: 0.02, max: 1 },
				{ name: 'accelerationMaximum', value: 0.2, max: 1 }
			],
			componentSeries: [{ id: 'psar' }]
		};
	}

	/**
	 * @return {object}
	 * @property {CircleMarker} circlePSAR
	 */
	_getMarkers() {
		return (
			this.markers || {
				circlePSAR: new CircleMarker()
			}
		);
	}

	/** @param {object} data Symbol data object */
	render(data) {
		const ctx = this.panel.rootContext;
		const dataPSAR = this._getDataMap(data.psar);

		this.markers.circlePSAR.render(
			ctx,
			dataPSAR,
			this.xScale,
			this.yScale,
			{
				color: this.params.style.color,
				fillColor: this.params.style.color,
				length: this.params.style.length
			}
		);
	}
}
